import { useContext } from 'react';
import cn from 'classnames';
import logoLight from '@assets/images/scriptix-blue-logo@2-1.png';
import logoDark from '@assets/images/scriptix-white-400x99.png';
import arborLogo from '@assets/images/arbor.png';
import { BrandingContext } from '@utils/providers/branding-context.tsx';
import { ThemeContext } from '@utils/providers/theme-context.tsx';

export default function PublicLogo({
  isLink = false,
  href = '#',
  className
}: {
  isLink?: boolean;
  href?: string;
  className?: string;
}) {
  const themeCtx = useContext(ThemeContext);
  const branding = useContext(BrandingContext);

  const theme = themeCtx?.theme ?? 'light';
  const key = branding?.key ?? null;
  const apiLogo = branding?.logoUrl ?? null;

  const defaultLogo = theme === 'dark' ? logoDark : logoLight;

  // Only use arbor logo if key is explicitly 'arbor', otherwise prioritize apiLogo or default
  const src = apiLogo || (key === 'arbor' ? arborLogo : defaultLogo);

  const img = (
    <img
      className={cn(
        'h-auto mx-auto shrink-0',
        isLink && 'cursor-pointer',
        className
      )}
      src={src}
      alt="Brand Logo"
      onError={e => {
        if (e.currentTarget.src !== defaultLogo) {
          e.currentTarget.src = defaultLogo;
        }
      }}
    />
  );

  return isLink ? (
    <a
      href={href}
      onClick={e => e.preventDefault()}
      className="flex justify-center"
    >
      {img}
    </a>
  ) : (
    <div className="flex justify-center">{img}</div>
  );
}
